import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./input";
import { cn } from "@/lib/utils";

const PasswordInput = React.forwardRef(({ className, containerClassName, ...props }, ref) => {
  const [show, setShow] = React.useState(false);
  return (
    <div className={cn("relative", containerClassName)}>
      <Input ref={ref} type={show ? "text" : "password"} className={cn("pr-10", className)} {...props} />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        className="absolute right-3 inset-y-0 my-auto flex items-center text-muted-foreground hover:opacity-70 transition-opacity"
        aria-label={show ? "Ocultar senha" : "Mostrar senha"}
        data-testid={props["data-testid"] ? `${props["data-testid"]}-toggle` : "password-toggle"}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
